export default __webpack_public_path__ + "static/screen_1_10-8c1e596d80dece25547b62aba5a3bc9d.svg";